import { useEffect } from 'react';

import { generateBlockId } from '../../utils';

// Returns undefined when no ID is available yet, signaling the consumer
// to skip rendering a CommentZone (avoids conflicts from multiple blocks
// sharing a fallback zone ID).
export const useBlockZoneId = (
  blockType: string,
  id: string | null | undefined,
  updateAttributes?: (attrs: { blockId: string }) => void,
): string | undefined => {
  useEffect(() => {
    if (!id && updateAttributes) {
      updateAttributes({ blockId: generateBlockId() });
    }
  }, [id, updateAttributes]);

  return id ? `${blockType}/${id}` : undefined;
};
